import { Access } from '../../enums';
import { Permission } from '../permission';

const ROSTER_KEY = 'roster';
export const ROSTER = {
  MANAGE: new Permission({
    key: `${ROSTER_KEY}:manage:${Access.WRITE}`,
    description: 'Dienste – Verwalten',
  }),

  ADMINISTRATE: new Permission({
    key: `${ROSTER_KEY}:administrate:${Access.WRITE}`,
    description: 'Dienstplan – Administrationsrecht',
  }),

  PRINT: new Permission({
    key: `${ROSTER_KEY}:print:${Access.WRITE}`,
    description: 'Dienstplan – Druckrecht',
  }),

  ACCESS: {
    READ: new Permission({
      key: `${ROSTER_KEY}:access:${Access.READ}`,
      description: 'Dienstplan – Leserecht',
    }),

    WRITE: new Permission({
      key: `${ROSTER_KEY}:access:${Access.WRITE}`,
      description: 'Dienstplan – Schreibrecht',
    }),

    LIMITED_READ: new Permission({
      key: `${ROSTER_KEY}:access-limited:${Access.READ}`,
      description: 'Dienstplan – begrenztes Leserecht',
    }),
  },

  WEEK_PLAN: new Permission({
    key: `${ROSTER_KEY}:week-plan:${Access.READ}`,
    description: 'Dienstplan – Wochenplan Leserecht',
  }),

  LISTS: new Permission({
    key: `${ROSTER_KEY}:lists:${Access.READ}`,
    description: 'Dienstplan – Listen Leserecht',
  }),

  VACATION_SCHEDULE: {
    READ: new Permission({
      key: `${ROSTER_KEY}:vacation-schedule:${Access.READ}`,
      description: 'Urlaubsplan – Leserecht',
    }),

    WRITE: new Permission({
      key: `${ROSTER_KEY}:vacation-schedule:${Access.WRITE}`,
      description: 'Urlaubsplan – Schreibrecht',
    }),
  },
};
